// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verified-badge {
  --verified-shape: polygon(
    50% 0%, 61% 8%, 75% 7%, 82% 19%,
    94% 25%, 93% 39%, 100% 50%, 92% 61%,
    93% 75%, 81% 82%, 75% 94%, 61% 93%,
    50% 100%, 39% 92%, 25% 93%, 18% 81%,
    6% 75%, 7% 61%, 0% 50%, 8% 39%,
    7% 25%, 19% 18%, 25% 6%, 39% 7%
  );
  position: relative;
  display: inline-grid;
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  place-items: center;
  margin-inline-start: 5px;
  border: 0;
  clip-path: var(--verified-shape);
  color: #ffffff;
  background: #ffffff;
  filter: drop-shadow(0 2px 3px rgba(185, 54, 8, .28));
  vertical-align: -2px;
}

.verified-badge::before {
  content: "";
  position: absolute;
  inset: 1px;
  z-index: -1;
  clip-path: var(--verified-shape);
  background: linear-gradient(145deg, #ff8748, #e95a13 58%, #c9430a);
}

.verified-badge svg {
  position: relative;
  z-index: 1;
  width: 8px;
  height: 8px;
  color: #ffffff;
  fill: #ffffff;
  stroke: #ffffff;
  stroke-width: 18;
}

.verified-badge--profile {
  width: 21px;
  height: 21px;
  margin-inline-start: 7px;
}

.verified-badge--profile svg {
  width: 9px;
  height: 9px;
}

@media (max-width: 600px) {
  .verified-badge--profile {
    width: 18px;
    height: 18px;
    margin-inline-start: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/reusable/VerifiedBadge.css"],"names":[],"mappings":"AAAA;EACE;;;;;;;GAOC;EACD,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,wBAAwB;EAC1B;AACF","sourcesContent":[".verified-badge {\n  --verified-shape: polygon(\n    50% 0%, 61% 8%, 75% 7%, 82% 19%,\n    94% 25%, 93% 39%, 100% 50%, 92% 61%,\n    93% 75%, 81% 82%, 75% 94%, 61% 93%,\n    50% 100%, 39% 92%, 25% 93%, 18% 81%,\n    6% 75%, 7% 61%, 0% 50%, 8% 39%,\n    7% 25%, 19% 18%, 25% 6%, 39% 7%\n  );\n  position: relative;\n  display: inline-grid;\n  flex: 0 0 auto;\n  width: 18px;\n  height: 18px;\n  place-items: center;\n  margin-inline-start: 5px;\n  border: 0;\n  clip-path: var(--verified-shape);\n  color: #ffffff;\n  background: #ffffff;\n  filter: drop-shadow(0 2px 3px rgba(185, 54, 8, .28));\n  vertical-align: -2px;\n}\n\n.verified-badge::before {\n  content: \"\";\n  position: absolute;\n  inset: 1px;\n  z-index: -1;\n  clip-path: var(--verified-shape);\n  background: linear-gradient(145deg, #ff8748, #e95a13 58%, #c9430a);\n}\n\n.verified-badge svg {\n  position: relative;\n  z-index: 1;\n  width: 8px;\n  height: 8px;\n  color: #ffffff;\n  fill: #ffffff;\n  stroke: #ffffff;\n  stroke-width: 18;\n}\n\n.verified-badge--profile {\n  width: 21px;\n  height: 21px;\n  margin-inline-start: 7px;\n}\n\n.verified-badge--profile svg {\n  width: 9px;\n  height: 9px;\n}\n\n@media (max-width: 600px) {\n  .verified-badge--profile {\n    width: 18px;\n    height: 18px;\n    margin-inline-start: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
